import { useCallback, useState } from "react";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import { useCreateDebounceHandler, useDebouncedCallback } from "../../../../common/hooks/use_debounced_callback";
import { useNavigate } from "react-router";
import { processError } from "../../../../common/utils/base_error";
import { evaluateParamValue } from "../../../../common/utils/params_utils";
import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { initialBancoPagamentoFiltersValues } from "../hooks/banco_pagamento_lista/filters";
import { DropDown } from "../../../../common/domain/models/dropdown";
import { IndiceReajuste } from "../../domain/models/indice_reajuste";
import { useIndiceReajusteListaPagination } from "../hooks/indice_reajuste_lista/pagination";
import { useIndiceReajusteListaFilters } from "../hooks/indice_reajuste_lista/filters";

type LoadIndiceReajusteListaState = {

    idsIndiceReajuste?: number[];
    codigo?: number | null;

    page?: number;
    rowsPerPage?: number;

}

export const useFinanceiroReajustesListaViewModel = () => {

    const {
        financeiro: {
            getIndiceReajusteDropDownUseCase,
            getAllIndiceReajusteUseCase,
            deleteIndiceReajusteUseCase,

        },
        commons: {

        },

    } = useDependencyInjection();

    // const hookForm = useForm<BancoPagamentoForm>({
    //     mode: "onSubmit",
    //     reValidateMode: "onSubmit",
    //     resolver: zodResolver(BancoPagamentoSchema),
    // });

    // const changeHistory = useChangeHistory({
    //     getAllLogAlteracaoUseCase,
    //     getAllLogAlteracaoByParentUseCase,
    //     onSetError: (e) => pushErrorNotification('Erro', [e]),
    // })

    const navigate = useNavigate();
    const { pushErrorNotification, pushWarnNotification, pushInfoNotification, setPageLoading } = usePageLoader();
    const debouncedRef = useCreateDebounceHandler(1500);

    const [openDeleteModal, setOpenDeleteModal] = useState(false);

    const [selectedIdIndiceReajuste, setSelectedIdIndiceReajuste] = useState<number>();

    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const [errorMessage, setErrorMessage] = useState<string>();
    const [indiceReajusteLista, setIndiceReajusteLista] = useState<IndiceReajuste[]>();
    const [ddlIndiceReajuste, setDdlIndiceReajuste] = useState<DropDown[]>();


    const filters = useIndiceReajusteListaFilters();
    const pagination = useIndiceReajusteListaPagination();





    //#region CARREGAMENTO.


    const loadIndiceReajusteLista = useCallback(async (funcState?: LoadIndiceReajusteListaState) => {

        try {

            const filteredCodigo = evaluateParamValue(funcState?.codigo, filters.codigo);
            const filteredIdsIndiceReajuste = funcState?.idsIndiceReajuste ?? filters.idsIndiceReajuste;

            const filteredPage = funcState?.page ?? pagination.page;
            const filteredRowsPerPage = funcState?.rowsPerPage ?? pagination.rowsPerPage;

            await getAllIndiceReajusteUseCase.getAllIndiceReajuste(
                filteredIdsIndiceReajuste,
                Number(filteredCodigo),

                filteredPage,
                filteredRowsPerPage,
            );

            setIndiceReajusteLista(getAllIndiceReajusteUseCase.items);

            pagination.setRowsPerPage(getAllIndiceReajusteUseCase.pageSize);
            pagination.setTotalItems(getAllIndiceReajusteUseCase.totalItems);
        } catch (e: unknown) {
            setIndiceReajusteLista([]);
            throw new Error("Falha ao buscar índices de reajuste!");
        }
    }, [
        filters,
        pagination,

        getAllIndiceReajusteUseCase,
    ]);


    const loadIndiceReajusteDropDown = useCallback(async () => {
        try {
            setPageLoading(true);
            const response = await getIndiceReajusteDropDownUseCase.getIndiceReajusteDropDown();
            setDdlIndiceReajuste(response);
        } catch (e: unknown) {
            pushErrorNotification('Error', processError(e, 'Falha ao buscar Indices de Reajuste!'));
        } finally {
            setPageLoading(false);
        }
    }, [getIndiceReajusteDropDownUseCase,
        pushErrorNotification]);


    //#endregion

    usePageStartBootstrap(async () => {
        try {
            if (indiceReajusteLista === undefined) {
                await loadIndiceReajusteLista();
                await loadIndiceReajusteDropDown();

            }
        } catch (e: unknown) {
            setErrorMessage(processError(e, "Falha ao buscar lista de indices de reajuste!")[0]);
        }
    });




    //#region NOVO/EDITAR.

    const handleNewIndiceReajuste = useCallback(() => {
        navigate("/FinanceiroReajuste_cadastro");
    }, [navigate]);

    const handleEditIndiceReajuste = useCallback((idIndiceReajuste: number | null) => {
        navigate("/FinanceiroReajuste_cadastro", { state: { idIndiceReajuste } });
    }, [navigate]);

    //#endregion



    //#region PAGINAÇÃO.



    const handleReload = useCallback(async () => {
        try {
            setLoading(true);
            await loadIndiceReajusteLista();
        } catch (e: unknown) {
            pushErrorNotification('Error', processError(e, 'Falha ao buscar lista de indices de reajuste!'));
        } finally {
            setLoading(false);
        }
    }, [loadIndiceReajusteLista]);


    const handlePageChange = useCallback(async (page: number) => {
        try {
            setLoading(true);
            pagination.setPage(page + 1);
            await loadIndiceReajusteLista({ page: page + 1 });
        } catch (e: unknown) {
            pushErrorNotification('Error', processError(e, 'Falha ao buscar lista de indice de reajuste!'));
        } finally {
            setLoading(false);
        }
    }, [pagination, loadIndiceReajusteLista]);


    const handleRowsPerPageChange = useCallback(async (rowsPerPage: number) => {
        try {
            setLoading(true);
            pagination.setPage(1);
            pagination.setRowsPerPage(rowsPerPage);
            await loadIndiceReajusteLista({ rowsPerPage, page: 1 });
        } catch (e: unknown) {
            pushErrorNotification('Error', processError(e, 'Falha ao buscar indice de reajuste!'));
        } finally {
            setLoading(false);
        }
    }, [pagination, loadIndiceReajusteLista]);

    //#endregion






    //#region DELECAO

    const handleIndiceReajusteDeleteOpenState = useCallback((idIndice: number | null, openState: boolean) => {
        if (openState) {
            if (idIndice) {
                setSelectedIdIndiceReajuste(idIndice);
                setOpenDeleteModal(true);
            } else {
                setSelectedIdIndiceReajuste(undefined);
                setOpenDeleteModal(false);
            }
        }
        setOpenDeleteModal(openState);
    }, []);


    const handleConfirmarDeletarIndiceReajuste = useCallback(async () => {
        try {

            setSaving(true);
            if (selectedIdIndiceReajuste) {
                await deleteIndiceReajusteUseCase.deleteIndiceReajuste(selectedIdIndiceReajuste)
                pushInfoNotification("Sucesso", "Indice de Reajuste Deletado com sucesso!", { isAutoFinish: true });
            } else {
                pushErrorNotification("Erro", "Não foi possivel deletar Indice de Reajuste!", { isAutoFinish: true });

            }

            await loadIndiceReajusteDropDown()
            await loadIndiceReajusteLista()
        } catch (e: unknown) {
            pushErrorNotification("Erro", processError(e, "Falha ao Deletar Contas!"));
        } finally {
            setSaving(false);
            setOpenDeleteModal(false);
            setSelectedIdIndiceReajuste(undefined)
        }
    }, [
        selectedIdIndiceReajuste,
        deleteIndiceReajusteUseCase,
        loadIndiceReajusteLista,
        loadIndiceReajusteDropDown,
        pushErrorNotification,
        pushInfoNotification]);


    //#endregion





    //#region PESQUISA.

    const handleIdsindiceReajusteChange = useDebouncedCallback(
        debouncedRef,
        (newValues: number[]) => {
            filters.setIdsIndiceReajuste(newValues)
            return async () => {
                try {
                    setLoading(true);
                    pagination.setPage(1);
                    await loadIndiceReajusteLista({ idsIndiceReajuste: newValues, page: 1 });
                } catch (e: unknown) {
                    pushErrorNotification("Error", processError(e, "Falha ao buscar Indices!"));
                } finally {
                    setLoading(false);
                }
            };
        }, [filters,
        pagination,
        loadIndiceReajusteLista]
    );
    const handleCodigoChange = useDebouncedCallback(
        debouncedRef,
        (newValue: string | null) => {
            const valorNormalizado =
                newValue && !isNaN(Number(newValue)) && newValue.trim() !== ""
                    ? Number(newValue)
                    : undefined;

            filters.setCodigo(valorNormalizado);
            return async () => {
                try {
                    setLoading(true);
                    pagination.setPage(1);
                    await loadIndiceReajusteLista({ codigo: valorNormalizado, page: 1 });
                } catch (e: unknown) {
                    pushErrorNotification("Erro", processError(e, "Falha ao buscar saldo!"));
                } finally {
                    setLoading(false);
                }
            };
        },
        [filters, pagination, loadIndiceReajusteLista]
    );


    const handleClearFilters = useCallback(async () => {
        try {
            setLoading(true);
            filters.clearFilters();
            pagination.setPage(1);
            await loadIndiceReajusteLista({
                ...initialBancoPagamentoFiltersValues,
                page: 1
            });
        } catch (e: unknown) {
            pushErrorNotification("Erro", processError(e, 'Falha ao buscar indices de reajuste!'));
        } finally {
            setLoading(false);
        }
    }, [filters, pagination, loadIndiceReajusteLista, pushErrorNotification]);

    //#endregion 

    return {
        loading,
        saving,
        indiceReajusteLista: indiceReajusteLista ?? [],
        errorMessage,
        filters,
        pagination,
        openDeleteModal,
        ddlIndiceReajuste: ddlIndiceReajuste ?? [],
        selectedIdIndiceReajuste,

        handleNewIndiceReajuste,
        handleEditIndiceReajuste,
        handleIdsindiceReajusteChange,
        handleCodigoChange,
        handleReload,
        handlePageChange,
        handleRowsPerPageChange,
        handleClearFilters,
        handleIndiceReajusteDeleteOpenState,
        handleConfirmarDeletarIndiceReajuste

    };
}


